<div class="background-hack"></div>

@if (content) {
  <main class="container">
    <section class="col-8 mx-auto text-center">
      <header>
        <h1>{{content.headline}}</h1>
      </header>
      <div class="row">
        <div class="col-4 mx-auto">
          <div class="jumbotron">
            <h3 class="display-3">{{accuracyPercentage}}%</h3>
            <h4>
              Accuracy<br>
              <i class="fa fa-bullseye"></i>
            </h4>
          </div>
        </div>
        @if (!isStrategy && exerciseService.currentExercise.showOpenAnswerEnabled == 1) {
          <div class="col-8">
            <form>
              <div class="form-group">
                <label for="exerciseOpenAnswer" class="sr-only">Your answer</label>
                <!--      Todo: Wire up content field here      -->
                <textarea [formControl]="openAnswerForm.get('openAnswer')" required
                class="form-control" id="exerciseOpenAnswer" rows="8" placeholder="Open Answer Placeholder"></textarea>
                <!--TODO: Style the error below properly, not sure what the best way is-->
                @if (formService.controlHasError( openAnswerForm.get('openAnswer'), 'required')) {
                  <div>This field is required
                  </div>
                }
              </div>
              <button type="submit" class="btn btn-primary btn-block"
              [disabled]="!openAnswerForm.valid || isSubmitting" (click)="submitForm()">Submit</button>
            </form>
          </div>
        }
      </div>
      <div class="my-3">
        <markdown ngPreserveWhitespace>{{content.copy}}</markdown>
      </div>
      <div class="row justify-content-center">
        @if (!isStrategy && accuracyPercentage !== 100 ) {
          <div class="col-5">
            <button class="btn btn-success btn-lg btn-block text-white" (click)="onPersistedRound()">{{content.persistenceButtonText}}</button>
          </div>
        }
        <div class="col-5">
          <a class="btn btn-primary btn-lg btn-block center" [routerLink]="['/']">{{content.completeButtonText}}</a>
        </div>
      </div>
    </section>
  </main>
}
